










import { Vue, Component, Prop, Emit } from 'vue-property-decorator';
import { setBatchEnable } from '@/utils/api';

@Component({
  components: {},
})
export default class TipDialog extends Vue {
  @Prop({ default: () => [] }) selectRowIdData!: Array<string>;
  @Emit('success') submitSuccessEmit(msg?: any) {
    return msg;
  }
  title: string = '提示';
  tipText: string = '';
  dialogVisible: boolean = false;
  loading: boolean = false;
  type: string = '';
  getTitle(val) {
    switch (val) {
      case 'deactivate':
        this.tipText = '确认批量停用所选用户?';
        break;
      case 'enable':
        this.tipText = '确认批量启用所选用户？';
        break;
    }
  }
  openDialog(val) {
    this.type = val;
    this.dialogVisible = true;
    this.getTitle(val);
  }
  submitForm() {
    this.loading = true;
    const { selectRowIdData, type } = this;
    const status = type === 'enable' ? 'VALID' : 'INVALID';
    const tipMessage = type === 'enable' ? '批量启用成功！' : '批量停用成功！';
    const data = {
      status: status,
      usernames: selectRowIdData,
    };
    setBatchEnable(data)
      .then((res) => {
        console.log('res: ', res);
        this.submitSuccessEmit();
        this.dialogVisible = false;
        this.$message.success(tipMessage);
      })
      .catch((err) => {
        console.log('err:tipDialog ', err);
      })
      .finally(() => {
        this.loading = false;
      });
  }
}
